import type { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';

export const heroCarouselData: PageData = [
  {
    formId: 'formGroup1',
    heading: 'Hero Carousel Slides',
    data: [
      { id: 'tagline', label: 'Tagline', type: 'input' },
      { id: 'title', label: 'Title', type: 'textarea' },
      { id: 'description', label: 'Description', type: 'textarea' },
      { id: 'buttonText', label: 'Button text (leave blank to hide)', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      {
        id: 'image',
        label: 'Slide image',
        info: getIdealImageSize(616, 345),
        type: 'image'
      },
      { id: 'order', label: 'Slide order (e.g. 1 for first)', type: 'input' }
    ]
  }
];

export const introData: PageData = [
  {
    formId: 'form1',
    heading: 'Community Map and News',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      {
        id: 'mapLocationImage1',
        label: 'Map background image',
        info: getIdealImageSize(845, 281),
        type: 'image'
      },
      { id: 'mapTitle', label: 'Map title', type: 'input' },
      { id: 'mapSubtitle', label: 'Map subtitle', type: 'input' },
      { id: 'mapLinkText1', label: 'Map link 1 text', type: 'input' },
      { id: 'mapLinkUrl1', label: 'Map link 1 URL', type: 'input' },
      { id: 'mapLinkText2', label: 'Map link 2 text', type: 'input' },
      { id: 'mapLinkUrl2', label: 'Map link 2 URL', type: 'input' },
      { id: 'newsTitle', label: 'News title', type: 'input' },
      { id: 'newsSubtitle', label: 'News subtitle', type: 'input' },
      { id: 'newsDetails', label: 'News more details text', type: 'input' }
    ]
  }
];

export const partnersData: PageData = [
  {
    formId: 'form1',
    heading: 'Partners Section',
    data: [
      { id: 'title2', label: 'Meet Our Partners Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'heading', label: 'Heading', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Other Partner Logo',
    data: [
      {
        id: 'logo',
        label: 'Partner Logo',
        info: getIdealImageSize(120, 'auto'),
        type: 'image'
      }
    ]
  },
  {
    formId: 'formGroup2',
    heading: 'Partner Cards',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      { id: 'icon', label: 'Icon', info: getIdealImageSize(48, 48), type: 'image' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(411, 546), type: 'image' },
      { id: 'color', label: 'Background colour', type: 'input' },
      { id: 'textColor', label: 'Text colour', type: 'input' }
    ]
  }
];

export const aboutData: PageData = [
  {
    formId: 'form1',
    heading: 'About Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      { id: 'image', label: 'Banner Image', info: getIdealImageSize(1280, 665), type: 'image' }
    ]
  }
];

export const clientData: PageData = [
  {
    formId: 'form1',
    heading: 'Client Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Client Details',
    data: [
      { id: 'clientTestimony', label: 'Client Testimony', type: 'textarea' },
      { id: 'clientName', label: 'Client Name', type: 'textarea' },
      {
        id: 'companyLogo',
        label: 'Company Logo',
        info: getIdealImageSize(24, 24),
        type: 'image'
      },
      { id: 'companyName', label: 'Company Name', type: 'textarea' },
      { id: 'clientImage', label: 'Client Image', info: getIdealImageSize(519, 560), type: 'image' }
    ]
  }
];

export const communityData: PageData = [
  {
    formId: 'form1',
    heading: 'Community Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      {
        id: 'image1',
        label: 'Background image',
        info: getIdealImageSize(1440, 744),
        type: 'image'
      }
    ]
  }
];

export const newsData: PageData = [
  {
    formId: 'form1',
    heading: 'News Section',
    data: [{ id: 'title', label: 'Title', type: 'input' }]
  }
];

export const reportData: PageData = [
  {
    formId: 'form1',
    heading: 'Report Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' },
      { id: 'image', label: 'Card Image', info: getIdealImageSize(456, 505), type: 'image' }
    ]
  }
];

export const faqData: PageData = [
  {
    formId: 'form1',
    heading: 'FAQ Section',
    data: [
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' },
      { id: 'content', label: 'Content', type: 'textarea' },
      { id: 'buttonText', label: 'Button text', type: 'input' },
      { id: 'buttonLink', label: 'Button link', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'FAQ: Questions and Answers',
    data: [
      { id: 'question', label: 'Question', type: 'textarea' },
      { id: 'answer', label: 'Answer', type: 'textarea' }
    ]
  }
];
